<template>
  <div id="app">
    <demo-mode />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
const default_layout = "default";
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
};
</script>

<style lang="scss">
/* Global Vuetify Dialog Alignment, Top Offset & Scroll Fix */
.v-dialog__content {
  align-items: flex-start !important;
  padding-top: 60px !important;
  padding-bottom: 40px !important;
  z-index: 9999 !important;
  overflow-y: auto !important;
}

.v-dialog {
  margin-top: 0 !important;
  margin-bottom: auto !important;
  max-height: calc(100vh - 100px) !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  border-radius: 20px !important;
  box-shadow: 0 25px 60px rgba(10, 15, 41, 0.4) !important;

  .v-card {
    display: flex !important;
    flex-direction: column !important;
    max-height: calc(100vh - 100px) !important;
    overflow: hidden !important;
  }

  .v-card__text,
  .v-card-text {
    overflow-y: auto !important;
    max-height: calc(100vh - 200px) !important;
    flex: 1 1 auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
}

.v-dialog__content--active {
  background: rgba(10, 15, 41, 0.45) !important;
  backdrop-filter: blur(4px) !important;
}

/* Universal Page Header & Sidebar Header Gradient */
.hero-header,
.gradient-header,
.card-header {
  background: linear-gradient(
    135deg,
    #1b49a3 0%,
    #3a67b1 45%,
    #0a0f29 100%
  ) !important;
}

/* Fix SweetAlert z-index so it always appears ABOVE all Vuetify dialogs, popups, and overlays */
.swal2-container {
  z-index: 999999 !important;
}

/* ==========================================================================
   GLOBAL EXECUTIVE DESIGN SYSTEM FOR ALL PAGES & VIEWS
   ========================================================================== */

.natcon-command-center,
.natcon-app-bg {
  background-color: var(--jci-bg-slate, #fafafc) !important;
}

/* Luxury Card Container */
.luxury-card {
  border-radius: 24px !important;
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden !important;
  width: 100% !important;
  box-shadow: 0 16px 40px rgba(10, 15, 41, 0.1) !important;
}

/* Grand Blue Gradient Hero Header & Elements */
.hero-header {
  position: relative !important;
  background: linear-gradient(
    135deg,
    #1b49a3 0%,
    #3a67b1 45%,
    #0a0f29 100%
  ) !important;
  overflow: hidden !important;
  color: #ffffff !important;

  .header-ambient-glow {
    position: absolute;
    top: -150px;
    right: -100px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(0, 151, 215, 0.25) 0%,
      transparent 70%
    );
    pointer-events: none;
  }

  .header-light-streak {
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.05) 50%,
      transparent 100%
    );
    transform: skewX(-25deg);
    pointer-events: none;
  }

  .hero-icon-container {
    width: 54px;
    height: 54px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .v-icon {
      color: #ffffff !important;
    }
  }

  .eyebrow-tag {
    font-size: 0.7rem !important;
    font-weight: 800 !important;
    color: #edbe38 !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase !important;

    .v-icon {
      color: #edbe38 !important;
    }
  }

  .hero-title {
    font-family: "Outfit", -apple-system, sans-serif !important;
    font-size: 1.75rem !important;
    font-weight: 900 !important;
    color: #ffffff !important;
    letter-spacing: -0.02em !important;
    line-height: 1.2 !important;
    margin-bottom: 0.25rem !important;
  }

  .hero-subtitle {
    font-size: 0.875rem !important;
    color: rgba(255, 255, 255, 0.85) !important;
    font-weight: 500 !important;
  }
}

/* Announcement & Info Banners */
.announcement-banner {
  background: rgba(237, 190, 56, 0.08) !important;
  border: 1px solid rgba(237, 190, 56, 0.35) !important;
  border-left: 4px solid #edbe38 !important;
  border-radius: 14px !important;
  padding: 0.875rem 1.25rem !important;

  .info-icon-halo {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(237, 190, 56, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .v-icon {
      color: #edbe38 !important;
    }
  }

  .banner-text {
    font-size: 0.85rem !important;
    color: #334155 !important;
    font-weight: 500 !important;
  }
}

/* Buttons System */
.btn-action-excel {
  background: #10b981 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
  transition: all 0.2s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(16, 185, 129, 0.3) !important;
  }
}

.btn-action-gold {
  background: #edbe38 !important;
  color: #0a0f29 !important;
  font-weight: 800 !important;
  transition: all 0.2s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(237, 190, 56, 0.35) !important;
  }
}

.btn-action-navy {
  background: #3a67b1 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  transition: all 0.2s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(58, 103, 177, 0.3) !important;
  }
}

.btn-action-danger {
  background: #ef4444 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  transition: all 0.2s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(239, 68, 68, 0.3) !important;
  }
}

.btn-primary-grand {
  background: linear-gradient(
    135deg,
    #0a0f29 0%,
    #3a67b1 50%,
    #0097d7 100%
  ) !important;
  color: #ffffff !important;
  font-weight: 800 !important;
  border-radius: 12px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 151, 215, 0.3) !important;
  }
}

.text-navy {
  color: #0a0f29 !important;
  font-family: "Outfit", sans-serif !important;
}

/* Action Toolbar Card */
.action-toolbar-card {
  background: rgba(248, 250, 252, 0.95) !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 18px !important;
}

/* Mobile Responsive Adjustments for Page Cards & Headers */
@media (max-width: 768px) {
  .hero-header {
    .hero-inner {
      padding: 1rem !important;
    }

    .hero-icon-container {
      width: 44px !important;
      height: 44px !important;
      border-radius: 12px !important;
      margin-right: 0.75rem !important;
    }

    .hero-title {
      font-size: 1.35rem !important;
    }

    .hero-subtitle {
      font-size: 0.8rem !important;
    }
  }

  .luxury-card {
    border-radius: 16px !important;
  }

  .main-card-body {
    padding: 1rem !important;
  }
}
</style>
